import { CanActivateFn, Router } from '@angular/router';
import { WorkflowService } from '../services/workflow.service';
import { inject } from '@angular/core';

export const medicalHistoryGuard: CanActivateFn = () => {
  const currentRoute = inject(WorkflowService).currentRoute;
  return currentRoute === 'patient-medical-history' ? true : inject(Router).navigate(['/']);

};
